import { Col } from "react-bootstrap";
import { IpropsCardChart } from "./Interfaces";
import Icon from "components/Icon";
import { Pie } from 'react-chartjs-2';
import { collect } from "utils/classes/collection";
import { useMemo } from "react";
import { getColors } from "./utils";
import { ChartOptions } from "chart.js";
import LoadCard from "./LoadCard";

export default function CardPie({
  values,xs,md,title,icon,load,
  tooltipCallbackLabel
}:IpropsCardChart){
  const data = useMemo(()=>{
    const l = collect(values).pluck('label').toArray();
    const d = collect(values).pluck('value').toArray();
    return {
      labels: l,
      datasets: [
        {
          data: d,
          ...getColors(),
          borderWidth: 1,
        },
      ],
    };
  },[values]);

  const options = useMemo(():ChartOptions<"pie">=>{
    return {
      plugins: {
        tooltip: {
          callbacks: {
            label: tooltipCallbackLabel
          }
        },
        legend:{
          position:'right',
          labels:{
            color:"grey"
          }
        }
      }
  }
  },[tooltipCallbackLabel]);

  return (
    <Col xs={xs} md={md} className="my-col">
      <div className="my-card">
        {
          title
          ?
          <div className="my-card-title">{icon?<Icon name={icon} styleFamily="regular"/>:<></>}<label>{title}</label></div>
          :
          <div className="my-card-title">{icon?<Icon name={icon}/>:<></>}</div>
        }
        {load?<LoadCard proportional/>:<Pie data={data} options={options}/>}
      </div>
    </Col>
  );
}